/* eslint-disable frontApplet/enforce-jsdoc */
import AppletError from './AppletError';
import { IBaseSosErrorParams } from './SosError';

export interface IAppletVideoErrorParams extends IBaseSosErrorParams {
	kind: 'appletVideoError';
}

export default class AppletVideoError extends AppletError {
	public static readonly PATH_TO_DOCS: string = '/sdk/content/js-video';

	constructor(parameters: IAppletVideoErrorParams) {
		super({
			...parameters,
			pathToDocs: AppletVideoError.PATH_TO_DOCS,
			kind: 'appletError',
			type: parameters.type ? parameters.type : 'AppletVideoError',
		});
	}
}
